import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { POST } from '../../config/api';
import { setTokens } from '../../helpers/tokenStorage';
import { routes } from '../../config/config';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import styles from './OTPScreen.module.css';

const OTPScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  const [verificationCode, setVerificationCode] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (verificationCode.length === 4) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [verificationCode]);

  const verifyCode = async (e) => {
    e.preventDefault();
    if (disabled || isSubmitting) return;

    setDisabled(true);
    setIsSubmitting(true);
    setError('');

    const response = await POST('/auth/verifyEmail', {}, {
      verificationCode: verificationCode.toString(),
      email,
    });

    setIsSubmitting(false);

    if (response.status === 200 && response.data) {
      // Successful verification
      const { accessToken, refreshToken, user, categories } = response.data;

      // Store tokens
      await setTokens(accessToken, refreshToken);

      // Store user data in localStorage
      if (user) {
        const userData = { ...user };
        delete userData.chats;
        localStorage.setItem('tellmiz_user', JSON.stringify(userData));
        if (user.unreadMessagesCount !== undefined) {
          localStorage.setItem('tellmiz_unreadMessagesCount', user.unreadMessagesCount.toString());
        }
        if (user.chats) {
          localStorage.setItem('tellmiz_chats', JSON.stringify(user.chats));
        }
      }

      if (categories) {
        localStorage.setItem('tellmiz_categories', JSON.stringify(categories));
      }

      // Navigate to reels screen
      navigate(routes.reels);
    } else if (response.error) {
      if (response.status === 401) {
        setError('Invalid verification code. Please try again.');
        navigate(-1);
      } else {
        setError(response.message || 'Verification failed. Please try again.');
        setDisabled(false);
      }
    } else {
      setError('Verification failed. Please try again.');
      setDisabled(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleResendCode = () => {
    // TODO: Implement resend code functionality
    alert('Resend code functionality to be implemented');
  };

  const handleChangeEmail = () => {
    navigate(-1);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={handleBack}>
          <ArrowBackIcon className={styles.backIcon} />
        </button>
        <h1 className={styles.title}>Verify Email</h1>
        <button className={styles.changeEmailButton} onClick={handleChangeEmail}>
          Change email
        </button>
      </div>

      <div className={styles.content}>
        <h2 className={styles.accountCreatedText}>Account Created Successfully</h2>
        <p className={styles.description}>
          Enter the 4-digit code that we have sent to your email, please check the junk
          folder too. <strong>{email}</strong>.
        </p>

        <form onSubmit={verifyCode} className={styles.form}>
          <input
            type="text"
            className={styles.otpInput}
            inputMode="numeric"
            pattern="[0-9]{4}"
            maxLength={4}
            value={verificationCode}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '');
              setVerificationCode(value);
            }}
            placeholder="0000"
            disabled={isSubmitting}
            autoFocus
            required
          />

          {error && <div className={styles.errorMessage}>{error}</div>}

          <button
            type="submit"
            className={`${styles.button} ${disabled || isSubmitting ? styles.disabledButton : ''}`}
            disabled={disabled || isSubmitting}
          >
            {isSubmitting ? 'Verifying...' : 'Continue'}
          </button>
        </form>

        <button
          type="button"
          className={styles.resendCode}
          onClick={handleResendCode}
        >
          Resend code
        </button>
      </div>
    </div>
  );
};

export default OTPScreen;

